// Hungarian

export default {

  component: {
    jobAdList: {
      title: 'Elérhető állások',
      jobs: 'állások',
      noJobAds: 'Jelenleg nincs elérhető állás.',
    },

    jobAdCard: {
      openUntil: date => `Érvényesség ideje: ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Köszönjük!',
      readyInfo: 'Jelentkezése beérkezett hozzánk és toborzónk hamarosan felveszi Önnel a kapcsolatot.',
      luck: 'Sok sikert!',
    },

    jobAdSeeYou: {
      title: 'Köszönjük.',
      description: 'Jelentkezését elmentettük, és küldtünk Önnek egy linket, ahol később folytathatja jelentkezését.',
    },

    unpublished: {
      title: 'Még nem jelent meg',
      info: 'Az álláshirdetést még nem jelentették meg.',
    },
  },

  page: {},

}
